import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { updateUserLatest } from '@spectee/graphql/mutations';

const document = gql(updateUserLatest);

export function useUpdateUser() {
  return useMutation(document);
}
